var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-menu",class:[("" + _vm.currentLanding)]},[_c('HeaderOptions',{attrs:{"currentLanding":this.currentLanding}}),_c('HeaderInsurances',{attrs:{"currentLanding":this.currentLanding}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }